"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatArray = void 0;
const flatArray = (arg) => {
    const recursiveArray = Array.isArray(arg) ? arg : [arg];
    // Why as 1? Typescript: Type instantiation is excessively deep and possibly infinite.
    const filtered = recursiveArray.flat(Infinity).filter((x) => !!x);
    return filtered.length !== 0 ? filtered : undefined;
};
exports.flatArray = flatArray;
//# sourceMappingURL=flatArray.js.map